// removed by extract-text-webpack-plugin
module.exports = {"viewed-buttons":"set-viewed-display__viewed-buttons___o7Yu6","button":"set-viewed-display__button___2x6vt"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/set-viewed-display.scss
// module id = 1332
// module chunks = 0